import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios'

Vue.config.productionTip = false;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_PATH
});


/**
 * Build the correct URL without append '/' between base path and domain
 */
axiosInstance.interceptors.request.use(function(config) {
  config.url = config.baseURL + config.url;
  return config;
}, function(err) {
  return Promise.reject(err);
});

/**
 * Control all responses
 */
axiosInstance.interceptors.response.use(function (config) {
  if(config.data.result === false) {
    return Promise.reject(config.data.data);
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

/**
 * Debug width Xdebug in local env (.env.development.local)
 */
if(process.env.NODE_ENV === 'local'){

  //Authorization token, must get your credentials: user:password
  const token = Buffer.from(process.env.VUE_APP_AUTHORIZATION, 'utf8').toString('base64');

  axiosInstance.interceptors.request.use(function(config) {
    config.url = config.url + '?XDEBUG_SESSION_START=' + process.env.VUE_APP_XDEBUG_KEY;
    config.headers.Authorization =  'Basic ' + token;
    return config;
  }, function(err) {
    return Promise.reject(err);
  });
}

Vue.prototype.$http = axiosInstance;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
